export function List() {
  return (
    <svg viewBox="0 0 24 24" fill="none">
      <rect x="5" y="14" width="14" height="2" rx="1" fill="currentColor"></rect>
      <rect x="5" y="8" width="14" height="2" rx="1" fill="currentColor"></rect>
    </svg>
  );
}
